/**
 * Ensec Locale Links
 * ------------------
 * När användaren är på /en/-sidor: rewrite:a alla interna länkar så de
 * också navigerar till /en/-versionen. Annars hoppar man tillbaka till
 * svenska sidan vid första klick.
 *
 * Hanterar:
 *  - <a href="/...">  (relativa absoluta sökvägar)
 *  - <a href="https://ensec.se/...">  (full URL — samma origin)
 *  - Klick på dynamiskt tillagda länkar (cart drawer, modaler osv)
 *  - Respekterar middle-click + modifier keys (ctrl/cmd/shift)
 *
 * Hoppar över:
 *  - Externa URL:er (andra domäner)
 *  - mailto:, tel:, javascript:, #-anchors
 *  - /cdn/, /api/, /account, /checkout, /customer_authentication (Shopify-internt)
 *  - Länkar som redan har /en/-prefix
 */
(function () {
  'use strict';

  // Endast aktivt på /en/-sidor
  var path = window.location.pathname || '';
  var IS_EN = path === '/en' || path.indexOf('/en/') === 0;
  if (!IS_EN) return;

  // ─────────────────────────────────────────────
  // FÖRSÄKRA att language-switcher visar EN på /en/-sidor
  // Liquid har race-conditions: request.path strippar /en/ på vissa
  // page-typer → SV visas felaktigt. Vi tvingar EN client-side.
  // ─────────────────────────────────────────────
  function forceEnglishLangBadge() {
    // Uppdatera kod-texten (.ensec-lang__code)
    document.querySelectorAll('.ensec-lang__code').forEach(function (el) {
      el.textContent = 'EN';
    });
    // Uppdatera flaggan (.ensec-lang__flag svg) — UK-flagga istället för SE
    document.querySelectorAll('.ensec-lang__button .ensec-lang__flag').forEach(function (el) {
      // UK-flagga SVG (samma som ensec-flag-svg snippet för 'en')
      el.innerHTML =
        '<svg viewBox="0 0 20 14" xmlns="http://www.w3.org/2000/svg">' +
        '<rect width="20" height="14" fill="#012169"/>' +
        '<path d="M0,0 L20,14 M20,0 L0,14" stroke="#FFF" stroke-width="2.4"/>' +
        '<path d="M0,0 L20,14 M20,0 L0,14" stroke="#C8102E" stroke-width="1"/>' +
        '<rect x="8.25" width="3.5" height="14" fill="#FFF"/>' +
        '<rect y="5.25" width="20" height="3.5" fill="#FFF"/>' +
        '<rect x="9" width="2" height="14" fill="#C8102E"/>' +
        '<rect y="6" width="20" height="2" fill="#C8102E"/>' +
        '</svg>';
    });
    // Uppdatera <html lang> så Chrome auto-translate respekterar
    if (document.documentElement.lang !== 'en') {
      document.documentElement.lang = 'en';
    }
  }
  // Kör direkt + igen vid load + efter eventuella mutations
  if (document.readyState !== 'loading') {
    forceEnglishLangBadge();
  } else {
    document.addEventListener('DOMContentLoaded', forceEnglishLangBadge);
  }
  window.addEventListener('load', forceEnglishLangBadge);
  setTimeout(forceEnglishLangBadge, 500);
  setTimeout(forceEnglishLangBadge, 1500);

  var SKIP_PREFIXES = ['/cdn/', '/api/', '/account', '/checkout', '/services/', '/wpm', '/policies/', '/customer_authentication'];

  function shouldSkip(href) {
    if (!href) return true;
    // External absolute URL
    if (href.indexOf('http://') === 0 || href.indexOf('https://') === 0) {
      try {
        var u = new URL(href);
        if (u.host !== window.location.host) return true; // annan domän
        href = u.pathname + u.search + u.hash;
      } catch (e) {
        return true;
      }
    }
    if (
      href.indexOf('mailto:') === 0 ||
      href.indexOf('tel:') === 0 ||
      href.indexOf('javascript:') === 0 ||
      href.charAt(0) === '#'
    ) {
      return true;
    }
    if (href.charAt(0) !== '/') return true;
    // Redan en /en/-länk
    if (href === '/en' || href.indexOf('/en/') === 0) return true;
    // Shopify-interna paths som vi inte vill röra
    for (var i = 0; i < SKIP_PREFIXES.length; i++) {
      if (href.indexOf(SKIP_PREFIXES[i]) === 0) return true;
    }
    return false;
  }

  function rewriteHref(a) {
    if (!a || a.dataset.ensecLocaleRewritten === '1') return;
    var raw = a.getAttribute('href');
    if (shouldSkip(raw)) {
      a.dataset.ensecLocaleRewritten = '1';
      return;
    }
    var newPath;
    if (raw.indexOf('http') === 0) {
      // Full URL på samma origin
      try {
        var u = new URL(raw);
        newPath = u.origin + '/en' + u.pathname + u.search + u.hash;
      } catch (e) {
        a.dataset.ensecLocaleRewritten = '1';
        return;
      }
    } else {
      // Relativ absolut path
      newPath = '/en' + raw;
    }
    a.setAttribute('href', newPath);
    a.dataset.ensecLocaleRewritten = '1';
  }

  function rewriteAllInDoc() {
    var anchors = document.querySelectorAll('a[href]');
    for (var i = 0; i < anchors.length; i++) {
      rewriteHref(anchors[i]);
    }
  }

  // Initial pass
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewriteAllInDoc);
  } else {
    rewriteAllInDoc();
  }

  // Observera nya länkar (cart drawer, modaler, infinite scroll osv)
  if (typeof MutationObserver !== 'undefined') {
    var debounce;
    var obs = new MutationObserver(function (mutations) {
      var hasNewLinks = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          hasNewLinks = true;
          break;
        }
      }
      if (!hasNewLinks) return;
      clearTimeout(debounce);
      debounce = setTimeout(rewriteAllInDoc, 50);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  // Safety net: hantera klick (ifall någon länk missades av rewrite)
  document.addEventListener(
    'click',
    function (e) {
      // Respektera modifier-keys / middle-click
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (e.button !== undefined && e.button !== 0) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var raw = a.getAttribute('href');
      if (shouldSkip(raw)) return;
      // Endast om href fortfarande saknar /en/-prefix
      if (raw.indexOf('/en/') === 0 || raw === '/en') return;
      // Tvinga rewrite vid klicket
      e.preventDefault();
      var newPath;
      if (raw.indexOf('http') === 0) {
        try {
          var u = new URL(raw);
          newPath = u.origin + '/en' + u.pathname + u.search + u.hash;
        } catch (err) {
          return;
        }
      } else {
        newPath = '/en' + raw;
      }
      window.location.href = newPath;
    },
    { capture: true }
  );
})();
